import { useState } from "react";
import { CButton, CCol, CLabel, CRow } from "@coreui/react";
import CatalogItem from "../../models/catalog-item";
import HasAnyPermissionComponent from "../permissions/HasAnyPermissionComponent";
import { successAlert } from "../utils/messages";
import CatalogItemSelect from "./CatalogItemSelect";
import CatalogItemUpdateModal from "./CatalogItemUpdateModal";

interface CatalogItemPickerProps {
  value: CatalogItem | null;
  currency: string;
  permissionNames: string[];
  onChange: (item: CatalogItem | null) => void;
}

const CatalogItemPicker: React.FC<CatalogItemPickerProps> = ({
  value,
  currency,
  permissionNames,
  onChange,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onCreated = (item?: CatalogItem) => {
    setShowModal(false);
    if (item !== undefined) {
      onChange(item);
      successAlert("Producto o servicio guardado.");
    }
  };

  return (
    <>
      <CRow className="mb-2" style={{ paddingRight: "46px" }}>
        <CCol xs={12} md={6}>
          <CLabel style={{ fontWeight: 600, fontSize: "0.8rem", color: "var(--theme-muted)", marginBottom: "3px" }}>
            Producto o servicio
          </CLabel>
          <div className="d-flex align-items-center">
            <div className="flex-grow-1" style={{ minWidth: 0 }}>
              <CatalogItemSelect value={value} onChange={onChange} />
            </div>
            <HasAnyPermissionComponent permissionNames={permissionNames}>
              <CButton
                type="button"
                color="primary"
                variant="outline"
                className="ml-2"
                title="Crear producto o servicio"
                onClick={() => setShowModal(true)}
              >
                <i className="fa fa-plus"></i>
              </CButton>
            </HasAnyPermissionComponent>
          </div>
        </CCol>
      </CRow>
      <CatalogItemUpdateModal
        show={showModal}
        currency={currency}
        onCancel={() => setShowModal(false)}
        onSuccess={onCreated}
      />
    </>
  );
};

export default CatalogItemPicker;
